const itens = [
  { cor: 'bg-green-500', label: 'Com registro' },
  { cor: 'bg-brand-500', label: 'Hoje (clique p/ registrar)' },
  { cor: 'bg-red-500', label: 'Sem registro (solicitar ajuste)' },
  { cor: 'bg-yellow-400', label: 'Solicitação pendente' },
  { cor: 'bg-red-400 opacity-70', label: 'Sem registro (fora do prazo)' },
  { cor: 'bg-gray-100 border border-gray-300', label: 'Futuro' },
]

export function LegendaCores() {
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-2">
      {itens.map((i) => (
        <div key={i.label} className="flex items-center gap-2">
          <span className={`h-3.5 w-3.5 rounded ${i.cor}`} />
          <span className="text-xs text-gray-600">{i.label}</span>
        </div>
      ))}
    </div>
  )
}
